export const colorTheme = {
  MEDIUM_PURPLE: "#aa7de6",
  DARK_PURPLE: "#7421b5",
  LIGHT_PURPLE: "#d4bbf1",
  GOLD: "#fbc400",
  GOLD_HOVER: "#F9D000",
}
